import { Component, OnInit } from '@angular/core';
import { Message } from '../../classes/Message';
import { IIncidentClosureReasonDTO } from '../../interfaces/incident';
import { IncidentsService } from '../../services';
import { MessageService } from 'primeng';

@Component({
  selector: 'incident-closure-admin',
  templateUrl: 'incident-closure-admin.component.html',
  styleUrls: ['incident-closure-admin.component.css'],
})
export class IncidentClosureAdminComponent implements OnInit {
  constructor(private incidentsService: IncidentsService, private messageService: MessageService) {}

  closureReasons: IIncidentClosureReasonDTO[] = [];
  closureReasonText: string = '';

  ngOnInit() {
    // load closure reasons
    this.loadReasons();
  }

  loadReasons() {
    this.incidentsService.getClosureReasons().then((res) => {
      this.closureReasons = res;
    });
  }

  addClosureReason() {
    var text = this.closureReasonText.trim();

    if (text == '') {
      this.messageService.add(Message.Error('Reason cannot be blank.', 'Error'));
      return;
    }

    if (
      this.closureReasons.findIndex((x) => x.reason.toLowerCase().trim() == text.toLowerCase()) >= 0
    ) {
      this.messageService.add(Message.Error('The closure reason already exists.', 'Error'));
    } else {
      let data = <IIncidentClosureReasonDTO>{
        reason: text,
      };

      this.incidentsService.addClosureReason(data).then(() => {
        this.loadReasons();
        this.closureReasonText = '';
      });
    }
  }

  reactivateClosureReason(item: IIncidentClosureReasonDTO) {
    this.incidentsService.activateClosureReason(item.id).then(() => this.loadReasons());
  }

  deactivateClosureReason(item: IIncidentClosureReasonDTO) {
    this.incidentsService.deactivateClosureReason(item.id).then(() => this.loadReasons());
  }
}
